import { defineMessages } from "react-intl";

export default defineMessages({
  activateAppTitle: {
    id: "cEO6Yx",
    defaultMessage: "Activate Extension",
    description: "dialog header",
  },
  activateApp: {
    id: "iK8hZU",
    defaultMessage:
      "Are you sure you want to activate this extension? Activating will start gathering events.",
    description: "activate app",
  },
  activateNamedApp: {
    id: "JbUg2b",
    defaultMessage:
      "Are you sure you want to activate {name}? Activating will start gathering events.",
    description: "activate app",
  },
});
